export const getters = {
    /** Total events recorded in the selected range, 0 before the first load. */
    totalEvents: (state) => state.overview?.total_events?.value ?? 0,

    /** Share of paywall views that turned into a purchase. */
    paywallConversionRate: (state) => state.overview?.paywall_conversion_rate ?? 0,

    /** The biggest drop between two consecutive funnel steps — where users are lost. */
    worstFunnelStep: (state) => {
        if (!state.funnel || state.funnel.length < 2) return null;

        return state.funnel
            .slice(1)
            .reduce(
                (worst, step) =>
                    worst === null || step.conversion_from_previous < worst.conversion_from_previous
                        ? step
                        : worst,
                null,
            );
    },
};
